"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: signup/signup-unauthenticated-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fsignup%2Fsignup-unauthenticated-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignupUnauthenticatedServiceClient = exports.SendDownloadSmsResponse = exports.StepConversionData = exports.SendDownloadSmsRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const protobufPackage = 'com.step.signup.proto';
function createBaseSendDownloadSmsRequest() {
    return {
        phone: '',
        partnerId: '',
        campaign: '',
        campaignId: '',
        siteId: '',
        subSiteId: '',
        clickId: '',
        clickLookback: '',
        stepConversionData: undefined,
        templateId: undefined,
    };
}
exports.SendDownloadSmsRequest = {
    fromJSON(object) {
        const message = {
            phone: isSet(object.phone) ? globalThis.String(object.phone) : '',
        };
        if (isSet(object.partnerId)) {
            message.partnerId = globalThis.String(object.partnerId);
        }
        if (isSet(object.campaign)) {
            message.campaign = globalThis.String(object.campaign);
        }
        if (isSet(object.campaignId)) {
            message.campaignId = globalThis.String(object.campaignId);
        }
        if (isSet(object.siteId)) {
            message.siteId = globalThis.String(object.siteId);
        }
        if (isSet(object.subSiteId)) {
            message.subSiteId = globalThis.String(object.subSiteId);
        }
        if (isSet(object.clickId)) {
            message.clickId = globalThis.String(object.clickId);
        }
        if (isSet(object.clickLookback)) {
            message.clickLookback = globalThis.String(object.clickLookback);
        }
        if (isSet(object.stepConversionData)) {
            message.stepConversionData = exports.StepConversionData.fromJSON(object.stepConversionData);
        }
        if (isSet(object.templateId)) {
            message.templateId = globalThis.String(object.templateId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.phone !== '') {
            obj.phone = message.phone;
        }
        if (message.partnerId !== undefined && message.partnerId !== '') {
            obj.partnerId = message.partnerId;
        }
        if (message.campaign !== undefined && message.campaign !== '') {
            obj.campaign = message.campaign;
        }
        if (message.campaignId !== undefined && message.campaignId !== '') {
            obj.campaignId = message.campaignId;
        }
        if (message.siteId !== undefined && message.siteId !== '') {
            obj.siteId = message.siteId;
        }
        if (message.subSiteId !== undefined && message.subSiteId !== '') {
            obj.subSiteId = message.subSiteId;
        }
        if (message.clickId !== undefined && message.clickId !== '') {
            obj.clickId = message.clickId;
        }
        if (message.clickLookback !== undefined && message.clickLookback !== '') {
            obj.clickLookback = message.clickLookback;
        }
        if (message.stepConversionData !== undefined) {
            obj.stepConversionData = exports.StepConversionData.toJSON(message.stepConversionData);
        }
        if (message.templateId !== undefined) {
            obj.templateId = message.templateId;
        }
        return obj;
    },
    create(base) {
        return exports.SendDownloadSmsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSendDownloadSmsRequest();
        message.phone = object.phone ?? '';
        message.partnerId = object.partnerId ?? '';
        message.campaign = object.campaign ?? '';
        message.campaignId = object.campaignId ?? '';
        message.siteId = object.siteId ?? '';
        message.subSiteId = object.subSiteId ?? '';
        message.clickId = object.clickId ?? '';
        message.clickLookback = object.clickLookback ?? '';
        message.stepConversionData =
            (object.stepConversionData !== undefined && object.stepConversionData !== null)
                ? exports.StepConversionData.fromPartial(object.stepConversionData)
                : undefined;
        message.templateId = object.templateId ?? undefined;
        return message;
    },
};
function createBaseStepConversionData() {
    return { code: '', segmentUserId: '' };
}
exports.StepConversionData = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.code)) {
            message.code = globalThis.String(object.code);
        }
        if (isSet(object.segmentUserId)) {
            message.segmentUserId = globalThis.String(object.segmentUserId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.code !== undefined && message.code !== '') {
            obj.code = message.code;
        }
        if (message.segmentUserId !== undefined && message.segmentUserId !== '') {
            obj.segmentUserId = message.segmentUserId;
        }
        return obj;
    },
    create(base) {
        return exports.StepConversionData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStepConversionData();
        message.code = object.code ?? '';
        message.segmentUserId = object.segmentUserId ?? '';
        return message;
    },
};
function createBaseSendDownloadSmsResponse() {
    return {};
}
exports.SendDownloadSmsResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SendDownloadSmsResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSendDownloadSmsResponse();
        return message;
    },
};
/**
 * Signup Unauthenticated Service API
 *
 * Allows caller to start the sign-up funnel by requested an app download link
 * sent to their phone number.
 */
class SignupUnauthenticatedServiceClient {
    rpc;
    name = 'com.step.signup.proto.SignupUnauthenticatedService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/signup';
    methods = [{
            name: 'SendDownloadSms',
            requestType: exports.SendDownloadSmsRequest,
            responseType: exports.SendDownloadSmsResponse,
            authenticationOptions: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Request a Step download link sent via SMS.
     */
    sendDownloadSms(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.SignupUnauthenticatedServiceClient = SignupUnauthenticatedServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=signup-unauthenticated-service.js.map